import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateQuestComponent } from './quests-creation/create-quest/create-quest.component';
import { CreateMindfulnessSessionComponent } from './mindfulness-creation/create-mindfulness-session/create-mindfulness-session.component';
import { AssignQuestsComponent } from './assign-quests/assign-quests.component';

@Component({
  selector: 'app-quest-mindfulness-creation',
  standalone: true,
  imports: [CommonModule, CreateQuestComponent, CreateMindfulnessSessionComponent, AssignQuestsComponent],
  templateUrl: './quest-mindfulness-creation.component.html',
  styleUrl: './quest-mindfulness-creation.component.css',
})
export class QuestMindfulnessCreationComponent {
  selectedTab: 'quest' | 'mindfulness' | 'assign-quests' = 'quest';
  isFormOpen = false;

  selectTab(tab: 'quest' | 'mindfulness' | 'assign-quests'): void {
    if (this.isFormOpen) {
      return;
    }
    this.selectedTab = tab;
  }

  onQuestCreated(): void {
    // Handle quest creation success
    console.log('Quest created successfully');
    // Reset form state to remove blur and enable tabs
    this.isFormOpen = false;
    this.selectedTab = 'quest';
  }

  onSessionCreated(): void {
    // Handle mindfulness session creation success
    console.log('Mindfulness session created successfully');
    // Reset form state to remove blur and enable tabs
    this.isFormOpen = false;
    this.selectedTab = 'mindfulness';
  }

  onFormOpened(): void {
    this.isFormOpen = true;
  }

  onBackToQuestTab(): void {
    // Reset to show placeholder when back is clicked
    this.isFormOpen = false;
    this.selectedTab = 'quest';
  }

  onBackToMindfulnessTab(): void {
    // Reset to show placeholder when back is clicked
    this.isFormOpen = false;
    this.selectedTab = 'mindfulness';
  }
}

